import React from 'react';
import {
  TableContainer,
  TableBody,
  TableBodyRow,
  TableHead,
  TableHeadCell,
} from '../../../../../../../components/tableComponents';

export const flatsTableComponents = {
  table: (props) => <TableContainer removePadding {...props} />,
  header: {
    wrapper: TableHead,
    cell: TableHeadCell,
  },
  body: {
    wrapper: TableBody,
    row: ({ expanded, ...props }) => (
      <TableBodyRow {...props} isExpanded={expanded} isClickable />
    ),
  },
};
